// extracted by mini-css-extract-plugin
module.exports = {"freeShippingIcon":"KRQpoz6jSNfHlgHvi_m1H"};